var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-form-model",
        {
          ref: "loginForm",
          staticClass: "ec-login-form switch-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            hideRequiredMark: "",
            colon: false,
            labelAlign: "left",
          },
        },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "userName",
                label: _vm.$t("common_form_login_name_or_phone"),
                htmlFor: "userName",
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "userName",
                    expression: "'userName'",
                  },
                ],
                attrs: { type: "text" },
                model: {
                  value: _vm.form.userName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "userName", $$v)
                  },
                  expression: "form.userName",
                },
              }),
            ],
            1
          ),
          _vm.captcha
            ? _c(
                "a-form-model-item",
                {
                  attrs: {
                    prop: "imgCode",
                    label: _vm.$t("common_form_identifying_code"),
                    htmlFor: "imgCode",
                  },
                },
                [
                  _c(
                    "a-input",
                    {
                      directives: [
                        {
                          name: "forlogin",
                          rawName: "v-forlogin",
                          value: "imgCode",
                          expression: "'imgCode'",
                        },
                      ],
                      attrs: { autoComplete: "off", maxLength: 4 },
                      model: {
                        value: _vm.form.imgCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "imgCode", $$v)
                        },
                        expression: "form.imgCode",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "56px",
                            height: "33px",
                            background: "rgb(253, 253, 253)",
                          },
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        },
                        [
                          _vm.imgCodeLoading
                            ? _c("a-spin", {
                                staticStyle: {
                                  "margin-left": "25px",
                                  "margin-top": "9px",
                                },
                                attrs: { size: "small" },
                              })
                            : _c("img", {
                                staticStyle: {
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "100%",
                                },
                                attrs: { src: _vm.imgCodeData },
                                on: { click: _vm.getImgCode },
                              }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "a-form-model-item",
            {
              attrs: {
                prop: "password",
                label: _vm.$t("common_form_login_pd"),
                htmlFor: "password",
              },
            },
            [
              _c("a-input-password", {
                directives: [
                  {
                    name: "forlogin",
                    rawName: "v-forlogin",
                    value: "password",
                    expression: "'password'",
                  },
                ],
                attrs: { type: "password" },
                on: {
                  keyup: function ($event) {
                    if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                      return null
                    return _vm.onSubmit.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a",
        {
          staticClass: "ec-login-submit",
          class: { "ec-login-submit__loading": _vm.submitLoading },
          on: {
            click: _vm.onSubmit,
            keyup: function ($event) {
              if (!$event.type.indexOf("key") && $event.keyCode !== 13)
                return null
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm.submitLoading
            ? _c(
                "a-spin",
                [
                  _c("a-icon", {
                    staticStyle: { "font-size": "24px", color: "#fff" },
                    attrs: { slot: "indicator", type: "loading", spin: "" },
                    slot: "indicator",
                  }),
                ],
                1
              )
            : _c("span", [_vm._v(_vm._s(_vm.$t("common_login_title")))]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ec-login-agreement" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("common_login_登录即表明您同意")))]),
          _c(
            "a-button",
            {
              attrs: { type: "link" },
              on: {
                click: function ($event) {
                  return _vm.$emit("agreement", "agreementVisible")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common_login_ServiceAgreement")))]
          ),
          _c("span", [_vm._v(_vm._s(_vm.$t("common_conj_and")))]),
          _c(
            "a-button",
            {
              attrs: { type: "link" },
              on: {
                click: function ($event) {
                  return _vm.$emit("agreement", "policyVisible")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common_login_PrivacyPolicy")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }